module.exports = __webpack_public_path__ + "static/media/badge-03-color.ec96f952.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badge/badge-03-color.svg
// module id = 243
// module chunks = 0